<template>
    <modal dialog="modal-x-sm" class="fluid narrow">
        <div slot="title">Edit note</div>

        <div slot="body">
            <div class="wrapper fs-normal">
                <textarea autofocus v-model="clonedNote.text"></textarea>
            </div>
        </div>

        <div slot="footer" class="d-flex flex-all">
            <vue-select v-model="clonedNote.type" :options="types" :searchable="false"></vue-select>
            <button type="button" class="btn yes wide ml-2" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'
    import VueSelect from 'vue-select'

    export default {
        data: function() {
            return {
                clonedNote: null,
                types: [
                    { id: 1, label: 'Public' },
                    { id: 2, label: 'Private' },
                ]
            }
        },
        created: function() {
            this.clonedNote = JSON.parse(JSON.stringify(this.getSelectedNote));
        },
        computed: {
            ...mapGetters([
                'getSelectedNote',
            ])
        },
        methods: {
            ...mapActions([
                'updateSelectedNote',
                'clearSelectedNote',
                'closeModal'
            ]),
            save: function() {
                this.updateSelectedNote(this.clonedNote);

                this.clearSelectedNote();

                // Modal closes after saving

                this.closeModal();
            }
        },
        components: {
            Modal,
            VueSelect
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';
    
    .add-note-modal {
        .modal-content {
            background-color: $lightest;

            textarea {
                background-color: $lighter;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// NoteEdit.vue?b4c06956